(async function () {
  function waitForTryNow(maxRetries = 50, interval = 100) {
    return new Promise((resolve, reject) => {
      let retries = 0;

      const check = () => {
        if (window.trynow) {
          resolve(window.trynow);
        } else {
          retries++;
          if (retries >= maxRetries) {
            reject(new Error("window.trynow did not load in time"));
          } else {
            setTimeout(check, interval);
          }
        }
      };

      check();
    });
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  try {
    await waitForTryNow();

    const rawSearch = window.location.search;
    const params = new URLSearchParams(rawSearch);

    const isMetaShopper =
      getCookie("_tnfb") === "true" || // Rely on SDK cookie
      (await window.trynow.blockFacebookReferredTraffic());

    if (isMetaShopper) {
      const style = document.createElement("style");
      style.innerHTML = `
        .trynow-slideshow,
        .trynow-subhero,
        #trynow-pdp-banner,
        .trynow-collection-converter-container,
        .trynow-collection-card-container {
          display: none !important;
        }

        ProductMeta__PriceList.Heading.Price_List_Mobile.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--compareAt {
          display: unset !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--highlight {
          display: unset !important;
        }

        .ProductMeta__PriceList.Heading.Price_List_Desktop.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .original-slideshow,
        .original-image-with-text {
          display: block !important;
        }
      `;
      document.head.appendChild(style);
      console.log('RULES APPLIED!');

      document.cookie = "_tn_gate=; path=/; SameSite=Lax";
    }
  } catch (error) {
    console.warn("❌ Failed waiting for TryNow:", error);
  }
})();